// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + ".twh." + {"FavouritesUiDynamicBuyerInfoModal":"2d3c5613","SmartBannerFullScreen":"418e5088"}[chunkId] + ".css";
};